export const locales = [
  {
    key: 'en',
    label: 'English',
  },
  {
    key: 'es',
    label: 'Español',
  },
  {
    key: 'fr',
    label: 'Français',
  },
  {
    key: 'id',
    label: 'Bahasa Indonesia',
  },
  {
    key: 'ko',
    label: '한국어',
  },
  {
    key: 'pt',
    label: 'Português',
  },
  {
    key: 'ru',
    label: 'Русский',
  },
  {
    key: 'zh',
    label: '中文',
  },
]
